import { render } from "./actionmodalnarrow.vue?vue&type=template&id=3a97660a&scoped=true"
import script from "./actionmodalnarrow.vue?vue&type=script&lang=js"
export * from "./actionmodalnarrow.vue?vue&type=script&lang=js"

import "./actionmodalnarrow.vue?vue&type=style&index=0&id=3a97660a&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a97660a"]])

export default __exports__